import { getSelctedTransactionId } from "../../global/selectors";

export const getTransaction = (state) => {
    return state.constructs.transactions.filter((tr) => tr.type === 7);
}

export const getSelectedTransactions = (state) => {
    let tr = getTransaction(state).find((i) => i.id === getSelctedTransactionId(state));

    if(tr !== undefined && tr.templateTransactions === undefined)
        tr.templateTransactions = []
    
    return tr;
}

export const getNestedTransactions = (state) => {
    //return state.constructs.transactions;
    return state.constructs.transactions.filter((tr) => tr.type === 9);
}

export const getAllTransactions = (state) => {
    return state.constructs.transactions;
}

export const getTransInAlphabeticalOrder = (state) => {

    const transactions = state.constructs.transactions

    const transInAlphabeticalOrder = transactions.sort(function (a, b) {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
    })

    const transList = transInAlphabeticalOrder.map(item => { return { label: item.name, value: item.id } })
    return transList;
}

export const getMainTransInAlphabeticalOrder = (state) => {

    const transactions = state.constructs.transactions.filter((tr) => tr.type === 7);;

    const transInAlphabeticalOrder = transactions.sort(function (a, b) {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
    })

    const transList = transInAlphabeticalOrder.map(item => { return { label: item.name, value: item.id } })
    return transList;
}

export const getTransactionsOfClusterlet = payload => state => {
    const { id } = payload

    const transactions = state.constructs.transactions.filter(item => {
        const clusterlets = item.clusterlets.map(item => item.id)
        if (clusterlets.includes(id)) return item;
    })

    const transInAlphabeticalOrder = transactions.sort(function (a, b) {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
    })

    return transInAlphabeticalOrder;
}

export const getMainTransactionsOfClusterlet = payload => state => {
    const { id } = payload

    const transactions = state.constructs.transactions.filter(item => {
        const clusterlets = item.clusterlets.map(item => item.id)
        if (clusterlets.includes(id) && item.type == 7) return item;
    })

    const transInAlphabeticalOrder = transactions.sort(function (a, b) {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
    })

    return transInAlphabeticalOrder;
}

export const getTransactionsAssociatedWithClusterlet = (transactions, payload) => {
        const { id } = payload ;
        let transactionsAssociated = [];
        transactions.forEach(item => {
           const clusterlet = item.clusterlets.find(ele => ele.id === id);
           if(clusterlet !== undefined) transactionsAssociated.push({transactionId: item.id, order: clusterlet.order, category: clusterlet.category});
        });
        
        return transactionsAssociated;
    }
    